// Kit « Anniversaires du jour » : catégories (pour qui ?), phrases (clés i18n → modifiables dans Admin › Traductions,
// 4 langues) et cartes de vœux servies depuis le web (URL absolue : visibles dans l'app sans rebuild, même les nouvelles).
const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "";

export const BIRTHDAY_CATEGORIES = [
  { key: "friend", labelKey: "birthdays.cat_friend", label: "Ami(e)" },
  { key: "spouse", labelKey: "birthdays.cat_spouse", label: "Mon époux · mon épouse" },
  { key: "family", labelKey: "birthdays.cat_family", label: "Famille" },
  { key: "church", labelKey: "birthdays.cat_church", label: "Frère · sœur en Christ" },
  { key: "pastor", labelKey: "birthdays.cat_pastor", label: "Pasteur · responsable" },
  { key: "other", labelKey: "birthdays.cat_other", label: "Collègue · connaissance" },
];
export const PHRASES_PER_CATEGORY = 4;

// Valeurs par défaut (fr) — la version affichée vient des traductions (Admin › Traductions › birthdays.<cat>_<n>).
export const BIRTHDAY_PHRASE_DEFAULTS = {
  friend_1: "Joyeux anniversaire {name} ! Que cette nouvelle année soit remplie de joie, de rires et de belles surprises 🎉🎂",
  friend_2: "Un ami comme toi, c'est un cadeau de Dieu. Très bel anniversaire, {name} ! 🙏🎈",
  friend_3: "Que le Seigneur te comble de ses bénédictions aujourd'hui et chaque jour de l'année ✨🎁",
  friend_4: "Profite à fond de ta journée, tu le mérites ! Joyeux anniversaire 🥳🎊",
  spouse_1: "Joyeux anniversaire mon amour ❤️ Merci d'être la plus belle bénédiction de ma vie.",
  spouse_2: "À toi que mon cœur aime : que Dieu te garde et te comble de joie en ce jour 🙏💕",
  spouse_3: "Chaque jour à tes côtés est un cadeau. Très joyeux anniversaire, mon trésor 🎂💖",
  spouse_4: "Que cette nouvelle année de ta vie soit douce et bénie, comme tu l'es pour moi 🌹✨",
  family_1: "Quelle chance de t'avoir dans ma famille ! Joyeux anniversaire {name} 🎂❤️",
  family_2: "Que Dieu te garde en bonne santé et te bénisse abondamment cette année 🙏✨",
  family_3: "Merci pour tout l'amour que tu nous donnes. Très bel anniversaire ! 🎁💐",
  family_4: "Une année de plus, mille raisons de rendre grâce. Joyeux anniversaire ! 🎉🙏",
  church_1: "Joyeux anniversaire {name} ! « L'Éternel te bénisse et te garde » (Nombres 6:24) 🙏✨",
  church_2: "Que cette nouvelle année soit remplie de la grâce et de la paix de notre Seigneur 🕊️🎂",
  church_3: "Quelle joie de marcher avec toi dans la foi ! Très bel anniversaire 🙏❤️",
  church_4: "« Je rends grâce à mon Dieu de tout le souvenir que je garde de toi » (Philippiens 1:3). Joyeux anniversaire ! 📖✨",
  pastor_1: "Joyeux anniversaire pasteur ! Merci pour votre dévouement et vos enseignements 🙏📖",
  pastor_2: "Que Dieu renouvelle vos forces et vous comble de sa sagesse cette nouvelle année ✨🎂",
  pastor_3: "Reconnaissant(e) pour votre exemple et votre accompagnement. Très bel anniversaire ! ❤️🙏",
  pastor_4: "Que le Seigneur vous bénisse abondamment, vous et votre famille 🕊️🎁",
  other_1: "Joyeux anniversaire {name} ! Je te souhaite une excellente journée 🎉",
  other_2: "Tous mes vœux de bonheur, de santé et de réussite pour cette nouvelle année 🎂✨",
  other_3: "Que cette journée soit à la hauteur de ta gentillesse. Bel anniversaire ! 🎈",
  other_4: "Une pensée pour toi en ce jour spécial : joyeux anniversaire et que Dieu te bénisse 🙏🎁",
};

// Phrases d'une catégorie, traduites et personnalisées ({name} → prénom) ; une traduction vidée dans l'admin masque la phrase.
export const phrasesFor = (catKey, t, firstName) =>
  Array.from({ length: PHRASES_PER_CATEGORY }, (_, i) => `${catKey}_${i + 1}`)
    .map((k) => (t(`birthdays.${k}`, BIRTHDAY_PHRASE_DEFAULTS[k]) || "").trim())
    .filter(Boolean)
    .map((p) => p.replace(/\{name\}/g, firstName || ""));

// Cartes : chemin web + catégories mises en avant (les autres restent accessibles après).
export const BIRTHDAY_CARD_DEFS = [
  { src: "/cards/birthday-1.jpg", cats: ["friend", "family", "other"] },
  { src: "/cards/birthday-2.jpg", cats: ["church", "pastor", "other"] },
  { src: "/cards/birthday-3.jpg", cats: ["friend", "family"] },
  { src: "/cards/birthday-4.jpg", cats: ["spouse"] },
  { src: "/cards/birthday-5.jpg", cats: ["spouse"] },
  { src: "/cards/birthday-6.jpg", cats: ["friend", "other"] },
  { src: "/cards/birthday-7.jpg", cats: ["friend", "family"] },
  { src: "/cards/birthday-8.jpg", cats: ["church", "pastor"] },
  { src: "/cards/birthday-9.jpg", cats: ["family"] },
  { src: "/cards/birthday-10.jpg", cats: ["pastor", "other", "spouse"] },
];
export const BIRTHDAY_CARDS = BIRTHDAY_CARD_DEFS.map((c) => c.src);

export const cardUrl = (src) => (src && src.startsWith("/") ? `${BACKEND_URL}${src}` : src || "");

// Cartes triées : celles de la catégorie d'abord (ordre stable ensuite).
export const cardsFor = (catKey) =>
  [...BIRTHDAY_CARD_DEFS].sort((a, b) => Number(b.cats.includes(catKey)) - Number(a.cats.includes(catKey)));
